import {SettingDetails} from './setting-details';
import {SettingListing} from './setting-listing';
import {ROUTES} from '../routes';
import {RouteObject} from 'react-router';
import {ProtectedRoute} from '../auth/require-authorization';

export const SettingRoutes: RouteObject = {
  path: ROUTES.ADMIN.SETTINGS.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.SETTINGS.INDEX.path,
      element: <SettingListing />,
    },
    {
      path: ROUTES.ADMIN.SETTINGS.DETAIL.path,
      element: <SettingDetails />,
    },
  ],
};